export default __webpack_public_path__ + "static/media/setting.b3d03846.svg";